import { query } from '@confluence/query-preloader-tools';

import type { EditorPreferencesQuery as EditorPreferencesQueryType } from './__types__/EditorPreferencesQuery';
import { EditorPreferencesQuery } from './EditorPreferencesQuery.graphql';

export const preloadEditorPreferenceQuery = () =>
	query<EditorPreferencesQueryType, {}>({
		query: EditorPreferencesQuery,
	});
